(function() {
  window["__patient_portal_global_vars__"] = {
    baseResourceUrl: "/{$GUI_ENVIRONMENT_NAME}/",
    AuthServerUrl: "{$ENVIRONMENT_NAME}/AuthenticationServer",
    WebApiUrl: "{$ENVIRONMENT_NAME}/RISWebServer",
    externalAuthentication: false,
    useBackendExternalAuthentication: true,
    externalLoginPageUrl: "{$ExternalLoginPageUrlWithoutOrigin}",
    loggerDefaults: {
      "appender": "browserConsole",
      "appenderLevel": "5",
      "loggerLevel": "5"
    },
    webForms: {
      patientSearchURL: "Web/app/light?{SSO_TOKEN}&action=PatientPortalPatientSearch&theme=dynamic&disable_timeout=true&ignore_timezone=true",
      patientDetailsURL: "Web/app/light?{SSO_TOKEN}&&action=PatientPortalPatientDetails&theme=dynamic&disable_timeout=true&ignore_timezone=true",
      moreInfoURL: "Web/app/light?{SSO_TOKEN}&&action=PatientPortalMoreInfo&theme=dynamic&disable_timeout=true&ignore_timezone=true",
    }
  };
})();
